export default () =>{
    let colors=["lightgreen","orange","violet","cyan","yellow"];

    return colors[Math.floor(Math.random()*colors.length)];
}